import React from 'react';

//Graveyard ecosystem logos
import tombLogo from '../../assets/img/apex_c.png';
import tShareLogo from '../../assets/img/ashares_c.png';
import tombLogoPNG from '../../assets/img/crypto_tomb_cash.png';
import tShareLogoPNG from '../../assets/img/crypto_tomb_share.png';
import tBondLogo from '../../assets/img/abonds_c.png';
import aUsdLogo from '../../assets/img/ausd_c.png';
import apexAshareLpLogo from '../../assets/img/apex_ashare_lp.png';

import tombFtmLpLogo from '../../assets/img/tomb_ftm_lp.png';
import tshareFtmLpLogo from '../../assets/img/tshare_ftm_lp.png';

import wftmLogo from '../../assets/img/ftm_logo_blue.svg';
import booLogo from '../../assets/img/spooky.png';
import zooLogo from '../../assets/img/zoo_logo.svg';
import shibaLogo from '../../assets/img/shiba_logo.svg';

const logosBySymbol: { [title: string]: string } = {
  //Real tokens
  //=====================
  APEX: tombLogo,
  TOMBPNG: tombLogoPNG,
  TSHAREPNG: tShareLogoPNG,
  ASHARE: tShareLogo,
  ABOND: tBondLogo,
  WFTM: wftmLogo,
  BOO: booLogo,
  SHIBA: shibaLogo,
  ZOO: zooLogo,
  'APEX-FTM-LP': tombFtmLpLogo,
  'ASHARE-FTM-LP': tshareFtmLpLogo,
  'APEX-ASHARE-LP': apexAshareLpLogo,
};

type LogoProps = {
  symbol: string;
  size?: number;
};

const TokenSymbol: React.FC<LogoProps> = ({ symbol, size = 64 }) => {
  if (!logosBySymbol[symbol]) {
    throw new Error(`Invalid Token Logo symbol: ${symbol}`);
  }
  return <img src={logosBySymbol[symbol]} alt={`${symbol} Logo`} width={size} height={size} />;
};

export default TokenSymbol;
